import { each } from 'lodash-es';
import { CSSProperties } from 'react';

import { Styles, generateClasses } from 'netline-ui';
import { EnvMode } from 'types';

export const environmentIndicatorClasses = generateClasses('EnvironmentIndicator', [
  'root',
  'stripe',
  'chip',
  'chipLabel',
  'chipIcon',
  'chipPinIcon',
] as const);

export const environmentIndicatorRootClasses = generateClasses(
  environmentIndicatorClasses.root,
  [EnvMode.Prod, EnvMode.Dev, EnvMode.Int, EnvMode.Test, EnvMode.Custom] as const,
  true,
);

export const environmentIndicatorChipClasses = generateClasses(
  environmentIndicatorClasses.chip,
  ['hidden'] as const,
  true,
);

const styles: Styles = ({
  theme: {
    palette: { dataTurquoise, dataOrange, dataGreen, dataPink },
    spacing,
  },
}) => {
  const envColorMap: Record<EnvMode, string> = {
    [EnvMode.Dev]: dataTurquoise[400],
    [EnvMode.Test]: '#F6C94C', // TODO: missing dataYellow in netline-ui
    [EnvMode.Int]: dataOrange[400],
    [EnvMode.Prod]: dataGreen[400],
    [EnvMode.Custom]: dataPink[400],
  };
  const envRules: Record<string, CSSProperties> = {};
  each(EnvMode, (mode) => {
    const color = envColorMap[mode];
    envRules[`&.${environmentIndicatorRootClasses[mode]}`] = {
      [`.${environmentIndicatorClasses.stripe}`]: { backgroundColor: color },
      [`.${environmentIndicatorClasses.chip}`]: { backgroundColor: color },
      [`.${environmentIndicatorClasses.chipIcon}`]: { color },
      [`.${environmentIndicatorClasses.chipPinIcon}`]: { color },
    };
  });

  return {
    ...envRules,
    [`.${environmentIndicatorClasses.stripe}`]: {
      height: 6,
      position: 'relative',
      zIndex: 1275,
    },
    [`.${environmentIndicatorClasses.chip}`]: {
      position: 'absolute',
      top: '0px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1250,
      gap: spacing(0.75),
      padding: spacing(0, 1, 0, 0.75),
      borderRadius: spacing(0, 0, 2, 2),
      transition: 'height 0.4s ease-in',
      overflow: 'hidden',
      [`&.${environmentIndicatorChipClasses.hidden}`]: {
        height: 0,
      },
    },
    [`.${environmentIndicatorClasses.chipLabel}`]: {
      padding: 0,
    },

    [`&& .${environmentIndicatorClasses.chipIcon}`]: {
      width: 20,
      height: 20,
      padding: spacing(0.25),
      marginRight: 0,
      backgroundColor: 'black',
    },
    [`&& .${environmentIndicatorClasses.chipPinIcon}`]: {
      margin: 0,
      marginLeft: spacing(0.75),
      color: 'black',
    },
  };
};
export default styles;
